export default "__VITE_ASSET__CHS8utH$__"